export default function placeholderPicker(groups, messages) {
  let root, dialog, request

  const notifyStale = () => window.dispatchEvent(new CustomEvent('notify', {
    detail: { type: 'danger', title: messages.title, message: messages.stale }
  }))

  return {
    search: '',
    activeIndex: 0,

    init() {
      root = this.$el
      dialog = root.querySelector(':scope > dialog')
    },

    get filteredGroups() {
      const query = this.search.trim().toLocaleLowerCase()
      return groups.map(group => ({
        ...group,
        entries: group.entries.filter(entry =>
          `${group.label} ${entry.label} ${entry.token}`.toLocaleLowerCase().includes(query))
      })).filter(group => group.entries.length > 0)
    },

    get entries() {
      return this.filteredGroups.flatMap(group => group.entries)
    },

    get activeId() {
      const entry = this.entries[this.activeIndex]
      return entry ? this.optionId(entry.token) : null
    },

    optionId(token) {
      return `${dialog.id}-${token}`
    },

    activate(event) {
      const detail = event.detail
      if (detail?.name !== 'membergy-placeholders' || event.target !== detail.editor ||
        !root.contains(detail.editor)) return

      if (request) this.cancel()
      request = detail
      this.search = ''
      this.activeIndex = 0
      dialog.showModal()
      this.$nextTick(() => dialog.querySelector('input')?.focus())
    },

    move(direction) {
      const count = this.entries.length
      this.activeIndex = count ? (this.activeIndex + direction + count) % count : 0
      const id = this.activeId
      if (id) document.getElementById(id)?.scrollIntoView?.({ block: 'nearest' })
    },

    selectActive() {
      const entry = this.entries[this.activeIndex]
      if (entry) this.choose(entry.token)
    },

    choose(token) {
      if (!request || !this.entries.some(entry => entry.token === token)) return
      const pending = request
      request = null
      // Release the native dialog before the package restores editor focus/range.
      dialog.close()
      if (!pending.insertText(token)) notifyStale()
    },

    cancel() {
      if (!request) return
      const pending = request
      request = null
      dialog.close()
      pending.cancel()
    },

    destroy() {
      this.cancel()
    }
  }
}
